<button
  #trigger="cdkOverlayOrigin"
  class="account-select__trigger"
  [class.active]="isListOpen"
  (click)="openMenu()"
  cdkOverlayOrigin
  mat-button
  type="button"
  [attr.data-e2e]="!e2e ? null : e2e + '__account-selector--button'"
>
  <span
    *ngIf="selectedAccount; else notSelectedAccount"
    class="account-select__selected-account"
  >
    <span class="external-name" ellipsisTitle>
      {{ selectedAccount.name }}
    </span>
    <span class="external-identifier">{{
      selectedAccount.externalIdentifier
    }}</span>
  </span>

  <ng-template #notSelectedAccount>
    <span>
      {{ "account_select.all_accounts" | translate | uppercase }}
    </span>
  </ng-template>

  <app-svg-icon fill="white" icon="arrow_dropdown" size="medium"></app-svg-icon>
</button>

<div
  *ngIf="selectedAccount?.status === inactiveAccountStatus"
  class="account-select__status-wrapper"
>
  <app-svg-icon icon="inactive" class="account-select__icon"></app-svg-icon>
  <span class="account-select__status">{{
    "account_select.account_blocked_status" | translate
  }}</span>
</div>

<ng-template
  #overlay="cdkConnectedOverlay"
  (backdropClick)="closeList()"
  (detach)="closeList()"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOpen]="isListOpen"
  [cdkConnectedOverlayOrigin]="trigger"
  cdkConnectedOverlay
>
  <div class="account-select-list">
    <header>
      <app-svg-icon icon="search" size="small"></app-svg-icon>

      <label>
        <input
          #searchInput
          (keydown)="onKeyDown($event)"
          (keyup)="search($event)"
          autocomplete="off"
          matInput
          placeholder="{{ 'account_select.search_account' | translate }}"
          [attr.data-e2e]="
            !e2e ? null : e2e + '__account-selector-search--input'
          "
        />
      </label>
    </header>

    <section>
      <div
        class="accounts"
        (scrolled)="loadAccounts()"
        [infiniteScrollDisabled]="!hasMoreData"
        [loadingAreaIndicatorActive]="isLoading"
        [scrollWindow]="false"
        [infiniteScrollThrottle]="50"
        infinite-scroll
        loading-area-indicator
      >
        <mat-selection-list
          (selectionChange)="onSelectionChange($event); isListOpen = false"
        >
          <ng-container *ngIf="showRecents">
            <h3 matSubheader>
              {{ "account_select.recent_accounts" | translate }}
            </h3>

            <mat-list-option
              *ngFor="let account of recentAccounts"
              [value]="account"
            >
              <ng-container
                *ngTemplateOutlet="
                  accountTemplate;
                  context: { account: account }
                "
              ></ng-container>
            </mat-list-option>

            <mat-divider></mat-divider>
          </ng-container>

          <mat-list-option *ngFor="let account of accounts" [value]="account">
            <ng-container
              *ngTemplateOutlet="accountTemplate; context: { account: account }"
            ></ng-container>
          </mat-list-option>

          <ng-template #accountTemplate let-account="account">
            <span class="account-select__option--left">
              <span
                class="account__name"
                [attr.data-e2e]="
                  !e2e ? null : e2e + '__account-selector-option-name'
                "
                ellipsisTitle
              >
                {{ account.name }}
              </span>
              <span
                class="account__external-identifier"
                [attr.data-e2e]="
                  !e2e ? null : e2e + '__account-selector-option-id'
                "
              >
                {{ account.externalIdentifier }}
              </span>
            </span>
            <span
              *ngIf="account.status === inactiveAccountStatus"
              class="account-select__option--right"
            >
              <app-svg-icon
                icon="inactive"
                class="account-select__icon"
              ></app-svg-icon>
              {{ "account_select.account_blocked_status" | translate }}
            </span>
          </ng-template>
        </mat-selection-list>
      </div>
    </section>
  </div>
</ng-template>
